module.exports = __webpack_public_path__ + "img/pantalla.253d5d54.png";